import { isly } from "isly";
import { CountryCode } from "../CountryCode";
export var Generic;
(function (Generic) {
    var _a;
    _a = isly
        .object({
        countryCode: CountryCode.Alpha2.type,
        street: isly.string(),
        zipCode: isly.string(),
        city: isly.string(),
        county: isly.string().optional(),
        state: isly.string().optional(),
    }, "isoly.Address.Generic")
        .bind(), Generic.type = _a.type, Generic.is = _a.is, Generic.flawed = _a.flawed;
})(Generic || (Generic = {}));
//# sourceMappingURL=Generic.js.map